'use client';

import { FC, useLayoutEffect } from 'react';
import { useAppDispatch } from '@/hotdesk-ui/hooks/hook';
import { fetchClientIpCountry } from '@/hotdesk-ui/helpers/client-ip-country';
import { setSessionIpCountry } from '@/hotdesk-ui/store/slices/geo-location.slice';
interface IpGeoBootstrapProps {
  ipCountryCode?: string;
}
const IpGeoBootstrap: FC<IpGeoBootstrapProps> = ({
  ipCountryCode
}) => {
  const dispatch = useAppDispatch();
  useLayoutEffect(() => {
    let cancelled = false;
    const resolveCountry = async () => {
      const fromEdge = ipCountryCode?.trim().toUpperCase();
      if (fromEdge && fromEdge.length === 2) {
        dispatch(setSessionIpCountry(fromEdge));
        return;
      }
      const fromIp = await fetchClientIpCountry();
      if (!cancelled && fromIp) {
        dispatch(setSessionIpCountry(fromIp));
      }
    };
    void resolveCountry();
    return () => {
      cancelled = true;
    };
  }, [dispatch, ipCountryCode]);
  return null;
};
export default IpGeoBootstrap;